import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useSection from '../../hooks/use-sections';
import ScrollUp from '../Home/ScrollUp';
import Sections from './Sections';
import StyledAboutUs from './styles';

import Footer from '../../containers/Footer';
import TopNavigation from '../../containers/TopNavigation';

const AboutUs = () => {
  const { sectionAboutUs } = useSection();
  const { i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <Box className={i18n.language === 'en-US' ? 'en' : 'kr'} sx={{ position: 'relative' }}>
      <TopNavigation />
      <Box
        sx={{
          minHeight: 'calc(100vh - 80px)',
          height: '100%',
          width: '100%',
          overflowX: 'visible',
          padding: '0 !important',
          marginTop: '80px',
        }}
      >
        <StyledAboutUs className="contact">
          <Sections sections={sectionAboutUs} />
          <ScrollUp />
        </StyledAboutUs>
      </Box>
      <Footer />
    </Box>
  );
};

AboutUs.propTypes = {
  sections: PropTypes.array,
};

export default AboutUs;
